module.exports = __webpack_public_path__ + "img/company-folder.7c86f181.svg";